import { Component } from '../jsti/core';

export default class Fader extends Component {
  items: Array<HTMLElement>;
  duration: number = 4000;
  activeClass: string = 'active';
  activeIndex: number = 0;

  // TODO: Add option to make the fader execute on mobile only, so it does not loop on desktop
  // When resized, it must start again
  /**
   *
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    this.items = Array.from(el.children);

    this.start();
  }

  /**
   * Start the fader
   */
  start(): void {
    setTimeout(() => this.next(), this.duration);
  }

  /**
   * Active the next item
   */
  next(): void {
    this.items[this.activeIndex].classList.remove(this.activeClass);
    this.setNextActiveIndex();
    this.items[this.activeIndex].classList.add(this.activeClass);

    setTimeout(() => this.next(), this.duration);
  }

  /**
   * Set the next active index
   */
  setNextActiveIndex(): void {
    if (this.activeIndex < (this.items.length - 1)) {
      this.activeIndex++;
    } else {
      this.activeIndex = 0;
    }
  }
}
